import React from 'react';
import { Helmet } from 'react-helmet-async';
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE } from '../../utils/seo';

/**
 * SEOHead - Dynamic per-page meta tags component
 *
 * Usage:
 *   <SEOHead title="Page Title" description="Page description" />
 *   <SEOHead title="Product Name" description="..." image="https://..." path="/products/123" type="product" />
 */
const SEOHead = ({
  title,
  description,
  image,
  path = '',
  type = 'website',
  noIndex = false,
  children,
  lang = 'ar',
  product = null,
}) => {
  const fullUrl = `${SITE_URL}${path}`;
  const ogImage = image || DEFAULT_OG_IMAGE;
  const fullTitle = title || `${SITE_NAME} | أثاث و ديكور المنزل في تونس`;
  const fullDescription =
    description ||
    'Darista - متجر أثاث و ديكور المنزل الأول في تونس. أثاث المطبخ، غرفة النوم، الصالون و الحمام بأسعار مميزة مع التوصيل لكامل الجمهورية.';

  return (
    <Helmet>
      {/* Basic */}
      <title>{fullTitle}</title>
      <meta name='description' content={fullDescription} />
      <link rel='canonical' href={fullUrl} />
      {noIndex && <meta name='robots' content='noindex, nofollow' />}

      {/* Open Graph */}
      <meta property='og:type' content={type === 'product' ? 'product' : 'website'} />
      <meta property='og:url' content={fullUrl} />
      <meta property='og:title' content={fullTitle} />
      <meta property='og:description' content={fullDescription} />
      <meta property='og:image' content={ogImage} />
      <meta property='og:site_name' content={SITE_NAME} />
      <meta property='og:locale' content={lang === 'ar' ? 'ar_TN' : 'en_US'} />

      {/* Twitter */}
      <meta name='twitter:card' content='summary_large_image' />
      <meta name='twitter:title' content={fullTitle} />
      <meta name='twitter:description' content={fullDescription} />
      <meta name='twitter:image' content={ogImage} />

      {/* Product-specific OG tags */}
      {product && product.price && (
        <meta
          property='product:price:amount'
          content={(product.price / 100).toFixed(2)}
        />
      )}
      {product && <meta property='product:price:currency' content='TND' />}
      {product && (
        <meta
          property='product:availability'
          content={product.stock > 0 ? 'in stock' : 'out of stock'}
        />
      )}

      {children}
    </Helmet>
  );
};

export default SEOHead;
